module.exports = __webpack_public_path__ + "img/checked-primary.7896dce9.svg";